<template>
  <q-page padding>
    <div class="row">
      <q-table
        title="Categorias"
        :rows="categories"
        :columns="columnsCategory"
        row-key="id"
        class="col-12"
        :loading="loading"
      >
        <template v-slot:top>
          <span class="text-h6">Categorias</span>
          <q-space />
          <q-btn
            v-if="$q.platform.is.desktop"
            dense
            icon="add"
            alt="Adicionar categoria"
            color="positive"
            size="sm"
            :to="{name: 'form-category'}"
          >
            <q-tooltip>
              Adicionar categoria
            </q-tooltip>
          </q-btn>
        </template>
        <template v-slot:body-cell-actions="props">
          <q-td :props="props">
            <div class="q-gutter-x-md">
              <q-btn
                icon="edit"
                alt="Editar"
                color="info"
                dense
                size="sm"
                @click="handleEditCategory(props.row)"
              >
                <q-tooltip>
                  Editar categoria
                </q-tooltip>
              </q-btn>
              <q-btn
                icon="delete"
                alt="Remover"
                color="negative"
                dense
                size="sm"
                @click="handleRemoveCategory(props.row)"
              >
                <q-tooltip>
                  Remover categoria
                </q-tooltip>
              </q-btn>
            </div>
          </q-td>
        </template>
      </q-table>
    </div>
    <q-page-sticky
      position="bottom-right"
      :offset="[18, 18]"
      v-if="$q.platform.is.mobile"
    >
      <q-btn
        fab
        icon="add"
        color="positive"
        padding="md"
        :to="{name: 'form-category'}"
      >
        <q-tooltip>
          Adicionar categoria
        </q-tooltip>
      </q-btn>
    </q-page-sticky>
  </q-page>
</template>
<script>
import { defineComponent, ref, onMounted } from 'vue'
import useApi from '../../composables/UseApi'
import useNotify from '../../composables/UseNotify'
import { useRouter } from 'vue-router'
import { useQuasar } from 'quasar'
import { columnsCategory } from './table'

export default defineComponent({
  name: 'PageListCategoria',

  setup () {
    const table = 'Categoria'
    const categories = ref([])
    const router = useRouter()
    const { list, remove } = useApi()
    const { notifyError, notifySuccess } = useNotify()
    const loading = ref(true)
    const $q = useQuasar()

    const handleListCategory = async () => {
      try {
        loading.value = true
        categories.value = await list(table)
        console.log(categories)
        loading.value = false
      } catch (error) {
        notifyError(error.message)
      }
    }

    const handleEditCategory = (category) => {
      router.push({ name: 'form-category', params: { id: category.id } })
    }

    const handleRemoveCategory = async (category) => {
      try {
        $q.dialog({
          title: 'Confirme',
          message: `Você realmente deseja remover  ${category.name}?`,
          cancel: true,
          persistent: true
        }).onOk(async () => {
          try {
            await remove(table, category.id)
            notifySuccess('Categoria removida com sucesso!')
            handleListCategory()
          } catch (error) {
            notifyError(error.message)
          }
        })
      } catch (error) {
        notifyError(error.message)
      }
    }

    onMounted(async () => {
      handleListCategory()
    })

    return { columnsCategory, categories, loading, handleEditCategory, handleRemoveCategory }
  }
})
</script>
